import visaSvg from '../assets/images/visa.svg';
import mastercardSvg from '../assets/images/mastercard.svg';
import amexSvg from '../assets/images/amex.svg';
import discoverSvg from '../assets/images/discover.svg';
import dinersClub from '../assets/images/diners.svg';
import jcb from '../assets/images/jcb.svg';
import { StripeCardElementOptions } from '@stripe/stripe-js';

export const CARD_ERROR_MESSAGES: { [key: string]: string } = {
  'card_declined': 'Your card was declined.',
  'expired_card': 'Your card has expired.',
  'incorrect_cvc': 'Your card\'s security code is incorrect.',
  'incorrect_number': 'Your card number is invalid.',
  'incomplete_number': 'Your card number is incomplete.',
  'incomplete_cvc': 'Your card\'s security code is incomplete.',
  'incomplete_expiry': 'Your card\'s expiration date is incomplete.',
  'invalid_expiry_month': 'Your card\'s expiration month is invalid.',
  'invalid_expiry_year': 'Your card\'s expiration year is invalid.',
  'invalid_cvc': 'Your card\'s security code is invalid.',
  'insufficient_funds': 'Your card has insufficient funds.',
  'default': 'An error occurred while processing your card.'
};

export const CREDIT_CARD_LOGOS = [
  { name: 'visa', image: visaSvg },
  { name: 'mastercard', image: mastercardSvg },
  { name: 'amex', image: amexSvg },
  { name: 'discover', image: discoverSvg },
  { name: 'diners', image: dinersClub },
  { name: 'jcb', image: jcb }
] as const;

export const CARD_ELEMENT_OPTIONS: StripeCardElementOptions = {
  style: {
    base: {
      fontSize: '16px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial',
      color: 'rgba(0, 0, 0, 0.85)',
      '::placeholder': {
        color: 'rgba(0, 0, 0, 0.45)'
      },
      iconColor: '#666EE8',
    },
    invalid: {
      color: '#ff4d4f',
      iconColor: '#ff4d4f'
    },
    complete: {
      iconColor: '#52c41a'
    }
  }
} as const; 